<template>
	<div>
		<v-alert icon="mdi-shield-lock-outline" prominent text type="info">
			<v-row>
				<v-col cols="12">
					ثبت واریزی به حساب نماینده
				</v-col>
			</v-row>
		</v-alert>
		<v-container>
			<div>
				<v-row>
					<v-col cols="12" md="7" style="">

						<v-form ref="form" class="mx-2" lazy-validation>
							<v-row>
								<v-col cols="12" md="6">
									<v-text-money ref="amount" v-model="localData.amount" :label="'*مبلغ'" :error-messages="errorMessages" :rules="[() => localData.amount > 0 || 'مبلغ را به صورت صحیح وارد کنید']" required />
								</v-col>
								<v-col cols="12" md="6">
									<div>
										<div>تاریخ واریز*</div>
										<date-picker ref="saveDate" v-model="localData.saveDate" format="YYYY-MM-DDTHH:mm:ss" auto-submit display-format="jYYYY/jMM/jDD" :error-messages="errorMessages" :rules="[() => !!localData.saveDate || 'تاریخ واریز را به صورت صحیح وارد کنید']" />
									</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="12" v-if="localData.isWithdraw && localData.userLoan">
									<div v-if="localData.userLoan" style="margin-bottom: -15px;">وام نماینده</div>
									<v-combobox v-model="localData.userLoan" clearable :items="userLoans" label="وام نماینده" single-line return-object :error-messages="errorMessages" item-text="title" item-value="id" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" md="12">
									<v-text-field ref="description" v-model="localData.description" :label="'توضیحات'" :error-messages="errorMessages" />
								</v-col>
							</v-row>
						</v-form>
					</v-col>
					<v-col cols="12" md="5">
						<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
							<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
							<span>فایل پیوست</span>
						</div>
						<ImageUploader ref="imageUploader" v-model="localData.base64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.base64)" @delete="() => localData.fileName = ''" />
					</v-col>
				</v-row>
			</div>

		</v-container>

		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark :loading="submitLoading" @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>

	</div>
</template>

<script>
	import { emptyId } from '@/util/emptyId'
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import ImageUploader from '@/components/uploader/ImageUploader'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'ModifySubAgentTransaction',
		components: {
			'date-picker': VuePersianDatetimePicker,
			ImageUploader,
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				regLoading: false,
				sendCodeVisible: true,
				overlayImgSrc: '',
				overlay: false,
				errorMessages: '',
				localData: { paymentMethod: 1, base64: '' },
				submitLoading: false,
				targetMonth: '',
				initValue: 0,
				userLoans: [],
			}
		},
		computed: {
			isNew() {
				return this.localData.id === emptyId
			},
			transactionTitle() {
				switch (this.data.paymentMethod) {
					case 1:
						return this.data.isWithdraw ? 'برداشت از صندوق' : 'واریز به صندوق'
					case 2:
						return this.data.isWithdraw ? 'برداشت از بانک' : 'واریز به بانک'
					case 3:
						return this.data.isWithdraw ? 'برداشت از جعبه طلا' : 'واریز به جعبه طلا'
					default:
						return 'تراکنش نامعلوم'
				}
			},
		},
		mounted() {
			this.prepareData().then(x => {
				if (this.localData.agent)
					this.loadAgents()

				if (this.localData.customerMarketerCommission)
					this.loadMarketers()
			})
		},
		methods: {
			submit() {
				const obj2FormData = (obj, formData = new FormData()) => {
					this.formData = formData
					this.createFormData = function (obj, subKeyStr = '') {
						for (let i in obj) {
							let value = obj[i]
							let subKeyStrTrans = subKeyStr ? subKeyStr + '[' + i + ']' : i

							if (typeof (value) !== 'object') {

								this.formData.append(subKeyStrTrans, value)

							} else if (typeof (value) === 'object') {

								this.createFormData(value, subKeyStrTrans)

							}
						}
					}
					this.createFormData(obj)
					return this.formData
				}
				// this.data.maxAmount
				if (typeof this.data.maxAmount !== 'undefined') {
					if (this.localData.amount > this.data.maxAmount) {
						toast.error('مبلغ وارد شده بیشتر از مانده سهم نماینده است.')
						return
					}
				}
				if (!this.$refs.form.validate()) { return }
				this.submitLoading = true
				let data = {}
				Object.assign(data, this.localData)
				delete data.base64
				delete data.saveDate_Persian
				const formData = obj2FormData(data)
				var fileUploader = this.$refs['imageUploader'] ? this.$refs['imageUploader'] : null
				if (fileUploader && fileUploader.hasFile()) {
					formData.append('file', fileUploader.getFile())
				}
				api.post('agent/subAgentTransaction/' + (this.localData.id === emptyId ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
						// this.localData.id = response.id
					})
					.catch(err => {
						toast.error(err.message)
						console.log("🚀 ~ file: ModifyTransaction.vue:372 ~ submit ~ err:", err)
					})
					.finally(x => { this.submitLoading = false })
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: emptyId, paymentMethod: 1 }
				}
				if (!this.data.id) {
					this.data.id = emptyId
				}
				return api.get('agent/subAgentTransaction/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = { ...response }
							if (this.data.id === emptyId)
								Object.assign(this.localData, this.data)
							else {
								this.initValue = response.amount
							}

							if (this.data.userLoan) {
								this.userLoans = [this.data.userLoan]
								this.localData.userLoan = this.data.userLoan
								if (this.data.id !== emptyId) {// in create mode, data.userLoan has title but in edit data.userLoan doesn't have title
									this.localData.userLoan.title = `شماره وام: ${this.data.userLoan.code}`
									this.userLoans[0].title = this.localData.userLoan.title
								}
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			viewImage(img) {
				this.overlay = true
				this.overlayImgSrc = img
			},
		},
	}
</script>
<style></style>
